export default __webpack_public_path__ + "static/media/Contactos-PT.03971d65.png";